import { useLoginState } from 'AppShell/hooks';

const useIsRegistered = (): boolean => {
    const { isRegistered } = useLoginState();

    return isRegistered;
};

export default useIsRegistered;
